/* ── CURSOR ── */
const dot=document.getElementById('cursorDot'),ring=document.getElementById('cursorRing');
if(dot&&ring){
  let mx=0,my=0,rx=0,ry=0;
  document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;dot.style.left=mx+'px';dot.style.top=my+'px'});
  (function anim(){rx+=(mx-rx)*.12;ry+=(my-ry)*.12;ring.style.left=rx+'px';ring.style.top=ry+'px';requestAnimationFrame(anim)})();
  document.querySelectorAll('a,button,.thumb,.bundle-opt,.faq-q,.hiw-card,.rev-card,.size-btn').forEach(el=>{
    el.addEventListener('mouseenter',()=>{ring.style.width='52px';ring.style.height='52px';ring.style.opacity='1'});
    el.addEventListener('mouseleave',()=>{ring.style.width='36px';ring.style.height='36px';ring.style.opacity='.5'});
  });
}

/* ── NAV + STICKY ── */
window.addEventListener('scroll',()=>{
  const nav=document.getElementById('mainNav');
  if(nav)nav.classList.toggle('scrolled',window.scrollY>10);
  const atc=document.getElementById('atc-btn'),bar=document.getElementById('stickyBar');
  if(atc&&bar){
    const r=atc.getBoundingClientRect();
    bar.classList.toggle('show',r.bottom<0);
  }
});

/* ── GALLERY ── */
function setImg(src,el){
  const img=document.getElementById('mainImg');
  img.style.opacity='0';
  img.style.transform='scale(.97)';
  setTimeout(()=>{img.src=src;img.style.opacity='1';img.style.transform='scale(1)';img.style.transition='opacity .3s ease,transform .3s ease'},150);
  document.querySelectorAll('.thumb').forEach(t=>t.classList.remove('active'));
  el.classList.add('active');
}
const mainImgEl=document.getElementById('mainImg');
if(mainImgEl)mainImgEl.style.transition='opacity .3s ease,transform .3s ease';

/* ── TABS ── */
function setTab(btn,id){
  document.querySelectorAll('.tab-btn').forEach(b=>b.classList.remove('on'));
  document.querySelectorAll('.tab-panel').forEach(p=>p.classList.remove('on'));
  btn.classList.add('on');
  document.getElementById(id).classList.add('on');
}

/* ── PRICING (display) ── */
const BUNDLES=[
  {tubs:1,price:49},
  {tubs:2,price:78,each:39,save:20},
  {tubs:3,price:102,each:34,save:45}
];
let currentBundle=0,subOn=true;

/* ── SUPPLY DURATION (T-approved display values per size × bundle) ── */
const SUPPLY=[
  ['~3 mo supply','~7 mo supply','~10 mo supply'],
  ['~6 wk supply','~3 mo supply','~4 mo supply'],
  ['~1 mo supply','~6 wk supply','~3 mo supply']
];
let currentSize=0;
function updateSizeHints(){
  for(let i=0;i<SUPPLY.length;i++){
    const el=document.getElementById('sizeSupply'+i);
    if(el)el.textContent=SUPPLY[i][currentBundle]||'';
  }
}
updateSizeHints();

function updatePrice(){
  const b=BUNDLES[currentBundle];
  const raw=b.tubs===1?b.price:(b.each*b.tubs);
  const displayed=subOn?Math.round(raw*.9):raw;
  document.getElementById('pfPrice').textContent='$'+displayed;
  document.getElementById('pfOrig').textContent='$'+raw;
  document.getElementById('pfOrig').style.display=subOn?'inline':'none';
  document.getElementById('pfSaveTag').style.display=subOn?'inline-flex':'none';
  const label=b.tubs>1?'$'+displayed+' total':'$'+displayed;
  document.getElementById('atcText').textContent='Add to Cart — '+label;
  document.getElementById('stickyPrice').textContent='$'+displayed;
}

/* ── SIZE ── */
function setSize(btn,label,idx){
  document.querySelectorAll('.size-btn').forEach(b=>b.classList.remove('on'));
  btn.classList.add('on');
  document.getElementById('sizeSel').textContent=label;
  currentSize=idx;
  selectBundle(document.getElementById('b'+idx),idx);
}

/* ── BUNDLE ── */
function selectBundle(el,idx){
  document.querySelectorAll('.bundle-opt').forEach(b=>b.classList.remove('on'));
  el.classList.add('on');
  currentBundle=idx;
  updatePrice();
  updateSizeHints();
}

/* ── SUBSCRIBE ── */
let currentPlanId=(window.REVITAPAW_SELLING_PLANS||[])[0]?.id||null;
function toggleSub(){
  subOn=!subOn;
  document.getElementById('togSw').classList.toggle('on',subOn);
  document.getElementById('subBody').classList.toggle('open',subOn);
  document.getElementById('subToggle').classList.toggle('on',subOn);
  updatePrice();
}
function setFreq(planId){
  currentPlanId=Number(planId);
}

/* ── ADD TO CART (real Shopify cart) ── */
function pickVariantId(){
  const variants=window.REVITAPAW_VARIANTS||[];
  if(!variants.length)return null;
  const tubs=BUNDLES[currentBundle].tubs;
  const re=new RegExp(tubs+'\\s*(bottle|tub)',"i");
  const match=variants.find(v=>re.test(v.title));
  return (match||variants[0]).id;
}

function addToCart(){
  const btn=document.getElementById('atc-btn');
  const orig=btn.innerHTML;
  const variantId=pickVariantId()||btn.dataset.variantId;
  const tubs=BUNDLES[currentBundle].tubs;
  const variants=window.REVITAPAW_VARIANTS||[];
  const hasBundleVariant=variants.some(v=>/(tubs?|bottles?)/i.test(v.title));
  const qty=hasBundleVariant?1:tubs;

  btn.disabled=true;
  const item={id:Number(variantId),quantity:qty};
  if(subOn&&currentPlanId)item.selling_plan=currentPlanId;
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:[item]})
  }).then(r=>{
    if(!r.ok)throw new Error('add failed');
    btn.style.background='var(--navy)';
    btn.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg><span>Added — going to cart…</span>';
    setTimeout(()=>{window.location='/cart'},800);
  }).catch(()=>{
    btn.innerHTML=orig;
    btn.disabled=false;
    window.location='/cart/add?id='+variantId+'&quantity='+qty;
  });
}

/* ── DELIVERY DATE ── */
(function(){
  const el=document.getElementById('delDate');
  if(!el)return;
  const now=new Date();
  const d1=new Date(now.getTime()+5*864e5);
  const d2=new Date(now.getTime()+7*864e5);
  const M=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  el.textContent=M[d1.getMonth()]+' '+d1.getDate()+' – '+M[d2.getMonth()]+' '+d2.getDate();
})();

/* ── FAQ ── */
function toggleFaq(btn){
  const item=btn.closest('.faq-item');
  const wasOpen=item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(i=>i.classList.remove('open'));
  if(!wasOpen)item.classList.add('open');
}

/* ── LOAD ANIMATIONS ── */
window.addEventListener('load',()=>{
  const seq=[
    {id:'pfSold',d:80},{id:'pfBrand',d:180},{id:'pfTitle',d:280},
    {id:'pfRating',d:380},{id:'pfPriceRow',d:460},
    {id:'pfBen1',d:560},{id:'pfBen2',d:630},{id:'pfBen3',d:700},{id:'pfBen4',d:770},
    {id:'pfDesc',d:860},{id:'pfTabs',d:940}
  ];
  seq.forEach(({id,d})=>setTimeout(()=>{
    const el=document.getElementById(id);
    if(el)el.style.cssText='opacity:1;transform:none;transition:opacity .5s ease,transform .5s cubic-bezier(.16,1,.3,1)';
  },d));
  setTimeout(()=>{
    ['gc1','gc2','gc3'].forEach((id,i)=>setTimeout(()=>{
      const el=document.getElementById(id);
      if(el)el.style.opacity='1';
    },i*150));
  },900);
});

/* ── SCROLL OBSERVER ── */
const io=new IntersectionObserver((entries)=>{
  entries.forEach(e=>{
    if(!e.isIntersecting)return;

    if(e.target.classList.contains('ing-cell')){
      e.target.classList.add('revealed');
      const bar=e.target.querySelector('.ic-fill');
      if(bar)setTimeout(()=>{bar.style.width=bar.dataset.w+'%'},200);
    }
    if(e.target.classList.contains('hiw-card'))e.target.classList.add('revealed');
    if(e.target.classList.contains('rev-card'))e.target.classList.add('revealed');
    if(e.target.classList.contains('fb-item'))e.target.classList.add('vis');
    if(e.target.classList.contains('ctr-num')&&!e.target.dataset.done){
      e.target.dataset.done='1';
      const target=+e.target.dataset.to,dur=1600,s=performance.now();
      (function tick(n){const p=Math.min((n-s)/dur,1),ease=1-Math.pow(1-p,4);e.target.textContent=Math.round(ease*target).toLocaleString();if(p<1)requestAnimationFrame(tick)})(performance.now());
    }
    io.unobserve(e.target);
  });
},{threshold:.15});

document.querySelectorAll('.ing-cell,.hiw-card,.rev-card,.fb-item,.ctr-num').forEach(el=>io.observe(el));

['.ing-row .ing-cell','.hiw-grid .hiw-card','.rev-grid .rev-card'].forEach(sel=>
  document.querySelectorAll(sel).forEach((el,i)=>{el.style.transitionDelay=i*90+'ms'})
);

const wrIO=new IntersectionObserver((entries)=>{
  entries.forEach(e=>{
    if(!e.isIntersecting)return;
    document.querySelectorAll('.wr-word').forEach((w,i)=>setTimeout(()=>w.classList.add('vis'),i*55));
    wrIO.unobserve(e.target);
  });
},{threshold:.2});
const wrSec=document.getElementById('wordReveal');
if(wrSec)wrIO.observe(wrSec);

/* ── SOCIAL PROOF ── */
const spNotifEl=document.getElementById('spNotif');
if(spNotifEl){
  const spData=[
    {av:'🐕',n:'Jessica M.',d:'just ordered 2 Bottles from Austin, TX',t:'2 minutes ago'},
    {av:'🐩',n:'Rachel T.',d:'just ordered 3 Bottles from Portland, OR',t:'4 minutes ago'},
    {av:'🦮',n:'Amanda K.',d:'just ordered 1 Bottle from Chicago, IL',t:'7 minutes ago'},
    {av:'🐶',n:'Megan L.',d:'just reordered — her 4th purchase!',t:'9 minutes ago'},
    {av:'🐕‍🦺',n:'Olivia S.',d:'just ordered 2 Bottles from Denver, CO',t:'12 minutes ago'},
  ];
  let spIdx=0;
  function showSP(){
    const d=spData[spIdx%spData.length];
    document.getElementById('spAv').textContent=d.av;
    document.getElementById('spN').textContent=d.n;
    document.getElementById('spD').textContent=d.d;
    document.getElementById('spT').textContent=d.t;
    spNotifEl.classList.add('show');
    setTimeout(()=>spNotifEl.classList.remove('show'),4500);
    spIdx++;
  }
  setTimeout(()=>{showSP();setInterval(showSP,9000)},4000);
}

// Init
updatePrice();
